import * as React from 'react'

import { Box, CheckBox, Text } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

interface Props {
  field: Field
  checked?: boolean
  disabled?: boolean
  label: string
}

const CheckboxInput = ({ field, checked, disabled, label }: Props) => {
  const onClick = () => {
    field.set(!field.value)
  }

  return (
    <>
      <Box
        flexDirection="row"
        alignItems="center"
        gap="s8"
        height="full"
        onClick={onClick}
        cursor="pointer"
      >
        <CheckBox checked={checked ?? field.value} disabled={disabled ?? false} />
        <Text size="300" weight="medium" color="grey800">
          {label}
        </Text>
      </Box>
    </>
  )
}

export default observer(CheckboxInput)
